import * as React from 'react';
import clx from 'classnames';
import { Typography } from 'antd';
const { Title } = Typography;
import './ProcedureTopFormTitle.scss';

export interface ProcedureTopFormTitleProps {
  children: React.ReactNode;
}

/**
 * Titolo della Domanda  posizionato prima del Modulo
 */
export function ProcedureTopFormTitle(props: ProcedureTopFormTitleProps) {
  return (
    <Title level={4} className={clx('procedure-top-form-title', {})}>
      {props.children}
    </Title>
  );
}
